import styled from 'styled-components';
import { themeMedia, themeStyles } from '../../../../../styles/theme';
import { Title } from '../../../../../atomic-components/atoms/text';
import ReferIcon from './../../../../../images/icon_refer_a_friend.svg';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 2rem 0;

  ${(props) => props.isPage && themeMedia.tablet`
    height: calc(100vh - 150px);
  `}

  ${(props) => props.isPage && themeMedia.navbarBreakpointTabletDesktop`
     height: calc(100vh - 240px);
  `}

  ${themeMedia.maxTablet`
    margin: 0.5rem 0;
    h1 { margin-bottom: 30px; }
  `}
`

export const StyledReferTitle = styled.div`
  padding-bottom: 40px;
  p { display: inline; }
  span { 
    border-bottom: 5px solid ${themeStyles.colors.accentColors.secondary.main};
    position: relative;
    &:after {
      display: block;
      content: '';
      width: 36px;
      height: 36px;
      position: absolute;
      background: url(${ReferIcon});
      background-size: 100%;
      right: -48px;
      top: 4px;
    }
  }
  img {
    position: relative;
    top: 3px;
    left: 12px;
    width: 30px;
    display: none;
  }
  ${themeMedia.tablet`
    span {
      border-bottom: 8px solid ${themeStyles.colors.accentColors.secondary.main};
    }
    span:after { display: none; } 
    img {
      display: inline;
      top: 4px;
      left: 16px;
      width: 42px;
    }
  `}
`

export const StyledTitle = styled(Title)`
  font-size: 48px;
  font-weight: 800;
  text-align: left;
  margin-bottom: 40px;

  ${themeMedia.maxTablet`
    font-size: 30px;
  `}

  ${(props) => props.isPage && themeMedia.desktop`
    font-family: unset;
    font-style: unset;
    text-transform: unset;
  `}
`;

export const StyledAlredyHaveAccountText = styled.p`
  font-size: 17px;
  text-align: center;
  margin-top: 40px;

  a {
    color: -webkit-link; 
  }
`

export const StyledResponsableGameText = styled.p`
  font-size: 14px;
  text-align: center;
`

export const StyledBottomDiv = styled.div`
 align-items: center;
 justify-content: center;
 display: flex;
 flex-direction: column;

 position: absolute;
 bottom: 30px;
 left: 0;
 right: 0;

  ${themeMedia.tablet`
    position: static;
    margin-top: ${(props) => props.isPage ? '30px' : '60px'};
  `}
`